export enum ProgressBarSLATypes {
  'LOAD_REQUEST' = '@progressBarSLA/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@progressBarSLA/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@progressBarSLA/LOAD_FAILURE',
}

export interface PropsSLA {
  protocolo: number;
  severidade: string;
  dtAbertura: string;
  correndo: boolean;
  tempoCorrido: number;
  sla1: Sla;
  sla2: Sla;
}

export interface Sla {
  definido: boolean;
  sucesso: boolean;
  tempoSla: number;
  tempoVencer: number;
}

export interface ProgressBarSLAState {
  readonly data: PropsSLA[];
  readonly loading: boolean;
  readonly error: boolean;
}
